function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 4.01953C7.30203 4.01953 7.54688 3.77469 7.54688 3.47266C7.54688 3.17063 7.30203 2.92578 7 2.92578C6.69797 2.92578 6.45312 3.17063 6.45312 3.47266C6.45312 3.77469 6.69797 4.01953 7 4.01953Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9498 2.05023C10.6276 0.728137 8.86977 0 7 0C5.13023 0 3.37239 0.728137 2.05023 2.05023C0.728137 3.37239 0 5.13023 0 7C0 8.86977 0.728137 10.6276 2.05023 11.9498C3.37239 13.2719 5.13023 14 7 14C8.28004 14 9.53252 13.6511 10.622 12.9912C10.8803 12.8347 10.9629 12.4984 10.8064 12.2401C10.6499 11.9818 10.3136 11.8992 10.0553 12.0557C9.13675 12.6121 8.08024 12.9062 7 12.9062C3.74328 12.9062 1.09375 10.2567 1.09375 7C1.09375 3.74328 3.74328 1.09375 7 1.09375C10.2567 1.09375 12.9062 3.74328 12.9062 7C12.9062 8.16454 12.5599 9.29808 11.9047 10.2781C11.7369 10.5291 11.8043 10.8688 12.0554 11.0366C12.3065 11.2045 12.6461 11.1371 12.814 10.886C13.5899 9.72546 14 8.38168 14 7C14 5.13023 13.2719 3.37239 11.9498 2.05023Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7 5.11328C6.69796 5.11328 6.45312 5.35812 6.45312 5.66016V10.5273C6.45312 10.8294 6.69796 11.0742 7 11.0742C7.30204 11.0742 7.54688 10.8294 7.54688 10.5273V5.66016C7.54688 5.35812 7.30204 5.11328 7 5.11328Z",
  fill: "currentColor"
});

function SvgNotificationicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/notification.icon.104e4f54.svg";
export { ForwardRef as ReactComponent };